import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { FirestoreService } from '../../../../services/firestore/firestore.service';
import { user } from '@angular/fire/auth';
import { UserDto } from '../../../../models/user-dto';
import { CommonModule } from '@angular/common';

@Component({
  imports:[CommonModule],
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css']
})
export class UserDetailsComponent implements OnInit {
  user:UserDto={
    id: '',
    email: '',
    fullName: ''
  }
  constructor(
    private route: ActivatedRoute,
    private firestoreService: FirestoreService
  ) {
    // Optional: Initialize with a default Observable if you prefer
  }

  ngOnInit(): void {
    // Get the user ID from the route parameter
    const uid = this.route.snapshot.paramMap.get('id');
    if (uid) {
      this.firestoreService.getById("users",uid).subscribe({
        next:res=>{
          this.user=res;
        }
      })
      
    } 
  }
}